import ReactTags from 'react-tag-autocomplete';
import {
  Container,
  StyledIcon,
  Icon,
  StyledTag,
} from './styles';
import { ErrorContainer } from '../../../styles/text';

const Input = ({
  error,
  name,
  register,
  formatterMap,
  onQueryChange,
  fields,
  nameMap,
  trigger,
  setError,
  append,
  remove,
  options,
  ...props
}) => {
  // api can contain different tag entities with same name
  const { suggestions: uniqueSuggestions } = options.reduce(({ suggestions, namesMap }, option) => {
    if (namesMap[option.name]) {
      return { suggestions, namesMap };
    }

    return {
      suggestions: suggestions.concat([{
        ...option,
        disabled: fields.find((item) => item.value === option.id),
      }]),
      namesMap: {
        ...namesMap,
        [option.name]: true,
      },
    };
  }, { suggestions: [], namesMap: {} });

  const onAddition = (tag) => {
    if(nameMap?.[tag.name] && !fields.find((item) => item.value === nameMap?.[tag.name])) {
      append({ value: nameMap?.[tag.name] });
    } else if(!fields.find((item) => item.value === tag.name || nameMap?.[item.value] === tag.name)) {
      append({ value: tag.name });
    }
  };

  const TagComponent = ({ tag }) => {
    const label = formatterMap?.[tag.name];

    return (
      <StyledTag isNew={!label}>
        {label || tag.name}
        {!props.readOnly
          && (
            <StyledIcon
              onClick={(e) => {
                e.preventDefault();
                remove(fields.findIndex((el) => el.id === tag.id));
              }}
              className="icon-close-1"
            />
          )}
      </StyledTag>
    );
  };

  return (
    <Container error={error}>
      <Icon className="icon-tag" />
      <ReactTags
        tags={fields.map((i, index) => ({
          id: fields[index].id,
          name: fields[index].value,
        }))}
        classNames={props.readOnly ? { root: 'react-tags-readonly' } : undefined}
        suggestions={uniqueSuggestions}
        placeholderText={fields.length ? '' : 'Add tags'}
        onAddition={onAddition}
        tagComponent={TagComponent}
        onInput={onQueryChange}
        maxSuggestionsLength={5}
        allowNew
        autoresize={fields.length > 0}
      />
      {error ? <ErrorContainer>{error.message}</ErrorContainer> : null}
    </Container>
  );
};

export default Input;
